/*
 * @Author: zhao - 🍉
 * @Date: 2021-09-22 18:13:40
 * @LastEditTime: 2022-01-14 17:18:03
 * @LastEditors: zhao - 🍉
 * @Description:
 * @FilePath: /zhzj-admin/src/components/FileView/index.jsx
 */
import { Tooltip } from "antd";
import React from "react";
import doc from "./images/doc.png";
import other from "./images/other.png";
import pdf from "./images/pdf.png";
import txt from "./images/txt.png";
import xls from "./images/xls.png";
import zip from "./images/zip.png";

class FileView extends React.Component {
    suffix = [
        { type: "doc", src: doc },
        { type: "docx", src: doc },
        { type: "pdf", src: pdf },
        { type: "txt", src: txt },
        { type: "xls", src: xls },
        { type: "xlsx", src: xls },
        { type: "zip", src: zip },
    ];

    getSuffix(src = "") {
        return src.split(".").slice(-1)[0];
    }

    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.src);
        }
    };

    render() {
        const type = this.getSuffix(this.props.src);
        const current = (type === "jpg" || type === "png" || type === "gif") ?
                        { type, src: this.props.src } :
                        (this.suffix.find((e) => e.type === type) || { type: "other", src: other })

        const formatText = (text) => {
            if (!text) return text;
            const max = this.props.maxText || 6;

            const minText = text.length > max ? text.substring(0, max) + ".." : text;
            return (
                <Tooltip title={text}>
                    <span>{minText}</span>
                </Tooltip>
            );
        };

        if (this.props.mode === "horizontal") {
            return (
                <div>
                    <img src={current.src} style={{ width: 30 }} alt="" />

                    {formatText(this.props.text)}
                </div>
            );
        }
        return (
            <div
                style={{
                    display: "inline-block",
                    textAlign: "center",
                    fontSize: 12,
                    color: "#888",
                    cursor: this.props.onClick ? "pointer" : "initial",
                }}
                onClick={this.handleClick}
            >
                <img src={current.src} style={{ width: 50, marginBottom: 10 }} width="50" alt="" />
                <br />
                {formatText(this.props.text)}
            </div>
        );
    }
}
export default FileView;



// WEBPACK FOOTER //
// ./src/components/FileView/index.jsx